import { routerMiddleware } from 'react-router-redux';
import history from '../../config/history';

export default routerMiddleware(history);
